import { env } from './env';

export const placeIDLink = `${env('REACT_APP_STATIC_URL')}/docs/Porto_Seguro_Guia_PlaceID_2025.pdf`;
